<template>
  <div class="quote__inclusive" :class="{'quote__inclusive_nolist': !isIncludes}">
    <div class="quote__header">
      <div class="quote__header-top">
        <div class="quote__title">
          {{$t('qic_quote_inclusive_covers')}}
          <template v-if="offerText">
            <span class="selectPlan__discount-badge">
              {{ offerText }}
            </span>
          </template>
          <template v-else>
            <span
              v-if="showDiscountPrice"
              class="quote__discount">
              {{quoteDiscount >= 1 ? `${discountTitle} &lrm;-${quoteDiscount}%` : $t('quote_discount') }}
            </span>
          </template>
        </div>
        <div
          v-if="!hidePrice"
          class="quote__price">
          <span v-show="priceWithoutDiscount && priceWithoutDiscount > quoteInclusivePrice" class="without-discount-top">
            {{$t('qic_qar')}} {{ getFixedPrice(priceWithoutDiscount) | splitNumber }}
          </span>
          {{$t('qic_qar')}} {{ getFixedPrice(quoteInclusivePrice) | splitNumber }}
        </div>
      </div>
      <div
        v-if="!hidePrice && deductibleValue"
        class="quote__desc" >
        {{$t('qic_quote_deductible')}}
        <span class="rtlQar">
          <i>
            {{$t('qic_qar')}}
          </i>
          {{ getFixedPrice(deductibleValue) | splitNumber }}
        </span>
      </div>
    </div>
    <div class="quote__list"  v-if="isIncludes">
      <div class="quote__accordion">
        <slot name="includes">
          <BaseAccordion
            v-for="(include, index) of sortedIncludes"
            :key="index"
            :disabled="!include[includeDeskKey] && !(include.benefits && include.benefits.length)">
            <template v-slot:name>
              {{ include[includeNameKey] }}
            </template>
            <template v-slot:content>
              <div class="quote__inclusive-ng" >
                <div class="quote__inclusive-optional">{{ include[includeDeskKey] }} </div>
                <div class="quote__subcover" v-if="include.benefits && include.benefits.length">
                  <div class="quote__subcover-item" v-for="(item, index) of include.benefits" :key="index">
                    <div class="quote__subcover-describe">
                      <span>{{ item.name }}</span> {{ item.description }}
                    </div>
                    <div class="quote__subcover-price" v-if="item.price && String(item.price).toLowerCase() !== 'yes' && String(item.price).toLowerCase() !== 'no'">
                      <span>{{ $t('qic_quote_insurance_limit') }}</span> {{ item.price }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </BaseAccordion>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
import { getFixed } from '../../utils/formatNumber.js'
export default {
  name: 'QuoteInclusive',
  props: {
    quoteInclusivePrice: { type: Number, required: true },
    quoteDiscount: { },
    deductibleValue: { },
    includes: { type: [Array, Boolean], default: false },
    includeNameKey: { type: String, default: 'name' },
    includeDeskKey: { type: String, default: 'description' },
    includePriceKey: { type: String, default: 'value' },
    priceWithoutDiscount: { type: Number, required: false },
    discountsArray: { type: Array, required: false },
    hidePrice: { type: Boolean, default: false },
    offerText: { type: String, default: '' }
  },
  components: {
    BaseAccordion
  },
  computed: {
    sortedIncludes () {
      return [...this.includes].sort((a, b) => {
        if (!a[this.includeDeskKey]) {
          return 1
        }
        return b[this.includeDeskKey] ? 1 : -1
      })
    },
    showDiscountPrice () {
      const isPriceVisible = !this.hidePrice
      const hasDiscount = this.quoteDiscount && this.priceWithoutDiscount > this.quoteInclusivePrice
      return isPriceVisible && hasDiscount
    },
    isIncludes () {
      if (typeof this.includes === 'boolean') {
        return this.includes
      }
      return this.includes && this.includes.length
    },
    discountTitle () {
      if (Array.isArray(this.discountsArray) && this.discountsArray.length === 1) {
        return this.discountsArray[0].name
      }
      return this.$t('qic_prequote_online_discount')
    }
  },
  methods: {
    getFixedPrice (value) {
      return getFixed(value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .quote__inclusive_nolist .quote__header{
    border-bottom: none;
  }
  .ltr {
    direction: ltr!important;;
  }
  .without-discount-top {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-decoration-line: line-through;
    color: rgba(82, 108, 130, 0.8);
    margin: 0 4px;
  }
  .inbound-additional_price {
    display: flex;
    justify-content: space-between;
    line-height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(28, 28, 28, 1);
    .description-cover {
      width: 80%;
      color: rgba(82, 108, 130, 0.8);
    }
    .price-cover {
      font-size: 14px;
      line-height: 24px;
      font-weight: 400;
      color: rgba(28, 28, 28, 1);
    }
  }
</style>
